export default "__VITE_ASSET__uQY4xWZF__"